import clsx from 'clsx';
import { CaretIcon } from 'components/Icon';
import { SVGProps } from 'react';
import styles from './BasicButton.css';

type ButtonVariant = 'fullColor' | 'outlined' | 'text';
interface BasicButtonProps {
	testId: string;
	label: string;
	variant?: ButtonVariant;
	icon?: React.FC<SVGProps<SVGSVGElement>>;
	showCaret?: boolean;
	customClass?: string;
	disabled?: boolean;
	onClick: () => void;
	caretClass?: string;
}

const variantToStyles: Record<ButtonVariant, string> = {
	fullColor: styles.fullColor,
	outlined: styles.outlined,
	text: styles.text,
};

export function BasicButton(props: Readonly<BasicButtonProps>) {
	const { testId, label, showCaret = false, customClass, variant = 'fullColor', onClick, caretClass } = props;

	const handleClick = () => {
		onClick();
	};

	return (
		<button data-testid={testId} className={clsx(styles.root, variantToStyles[variant], customClass)} onClick={handleClick}>
			<span className={styles.span}>
				{props.icon && <props.icon className={styles.icon} />}
				{label}
			</span>
			{showCaret && <CaretIcon className={clsx(styles.icon, caretClass)} />}
		</button>
	);
}
